export default "__VITE_ASSET__DmnYyM7p__"